export const GET_ALL_TECHNOLOGIES = 'GET_ALL_TECHNOLOGIES';


